import { Stepper as MuiStepper, styled } from '@mui/material'

export const StyledStepper = styled(MuiStepper)({
  width: '100%',
  padding: 16,
  marginLeft: -8,
  marginRight: -8
})
